import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation, OnChanges } from '@angular/core';
import { Customer, CustomerAccount } from '@inyova/models';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-fund-3a-contribution-level-header',
  templateUrl: './fund-3a-contribution-level-header.component.html',
  styleUrls: ['./fund-3a-contribution-level-header.component.scss'],
  standalone: false
})
export class Fund3aContributionLevelHeaderComponent implements OnInit, OnChanges {
  @Input() accountOpened: boolean;
  @Input() currentYear: string;
  @Input() maximumContributionLevel: string;
  @Input() maximumContributionAmount: number;
  @Input() customerData: Customer;
  @Input() currentAccount: CustomerAccount;
  @Input() showUnemployed3ANote: boolean;
  MINIMUM_INVESTMENT: number;

  ngOnInit() {
    this.MINIMUM_INVESTMENT = this.currentAccount.minimum_investment;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.currentAccount && (changes.currentAccount.currentValue as CustomerAccount).step_status >= 3) {
      this.MINIMUM_INVESTMENT = this.currentAccount.minimum_investment;
    }
  }
}
